package com.kinoshazam.screens.profile

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import com.kinoshazam.uiKit.components.textLabel.TextLabel
import com.kinoshazam.uiKit.components.textLabel.TextLabelState
import com.kinoshazam.uiKit.theme.BoldLarge
import com.kinoshazam.uiKit.theme.Large
import com.kinoshazam.uiKit.theme.UiKitTheme
import kinoshazam.resources.generated.resources.Res
import kinoshazam.resources.generated.resources.update_available
import kinoshazam.resources.generated.resources.update_yes
import org.jetbrains.compose.resources.stringResource

@Composable
fun ProfileUpdateStrip(
    versionName: String?,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
) {
    val title = buildString {
        append(stringResource(Res.string.update_available))
        versionName?.takeIf { it.isNotBlank() }?.let { append(" · v$it") }
    }
    Row(
        modifier = modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(8.dp))
            .background(UiKitTheme.colors.color_1)
            .clickable(onClick = onClick)
            .padding(horizontal = 16.dp, vertical = 14.dp),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.SpaceBetween,
    ) {
        TextLabel(
            state = TextLabelState(
                text = title,
                color = UiKitTheme.colors.color_2,
                textStyle = BoldLarge,
            ),
            modifier = Modifier.weight(1f),
        )
        TextLabel(
            state = TextLabelState(
                text = stringResource(Res.string.update_yes),
                color = UiKitTheme.colors.color_2,
                textStyle = Large,
            ),
        )
    }
}
